import React, { useState, forwardRef, useImperativeHandle, useEffect, useRef } from "react";
import StepperNavigationButtons from "../../Common/StepperNavigationButtons";
import ImageBrowse from "../../../../Common/Image/ImageBrowse";

const BirthdayDetails = forwardRef(function (props, ref) {

  const [section1Title, setSection1Title] = useState("");
  const [section1TagLine, setSection1TagLine] = useState("");
  const [section1ImageKey, setSection1ImageKey] = useState("");
  const section1ImageRef = useRef();

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (props.data) {

      if (props.data.length > 0) {
        setSection1Title(props.data[0].title);
        setSection1TagLine(props.data[0].tagLine);
        setSection1ImageKey(props.data[0].imageKey);

        section1ImageRef?.current?.setThumbnail(props.data[0].image);
        section1ImageRef?.current?.setFileContent(props.data[0].imageFile);
      }
    }
  }, [props.data]);


  const validate = () => {
    const errors = {};
    return Object.keys(errors).length === 0;
  }

  const getData = () => {
    return [
      {
        title: section1Title,
        tagLine: section1TagLine,
        image: section1ImageRef?.current?.getThumbnail() ?? null,
        imageFile: section1ImageRef?.current?.getImageFile() ?? null,
        imageKey: section1ImageKey
      }
    ]
  };

  useImperativeHandle(ref, () => ({
    getData: getData,
    validate: validate
  }));

  return (
    <>
      <div className="content d-block visible">
        <div className="content-header mb-3">
          <div className="sec-titler">
            <h2 className="text-primary">Birthday</h2>
            <div className="title-shape"></div>
            <small className="fs-11 mb-0"></small>
          </div>
        </div>

        <form>
          <div className="row g-3">
            <div className="col-sm-6">
              <div className="col-sm-12">
                <label className="form-label" htmlFor="section1Name">
                  Name
                </label>
                <input
                  type="text"
                  placeholder="Name"
                  name="section1Name"
                  id="section1Name"
                  className={`form-control ${errors.section1Title ? "is-invalid" : ""}`}
                  value={section1Title}
                  onChange={(e) => setSection1Title(e.target.value)}
                />
                {errors.section1Title && (
                  <div className="invalid-feedback">
                    {errors.section1Title}
                  </div>
                )}
              </div>

              <div className="col-sm-12 mt-4">
                <label className="form-label" htmlFor="section1Image">
                  Image <small className="text-gray">(Max Allowable File Size: 1MB,Dimensions: 750px x 750px)</small>
                </label>
                <ImageBrowse elementId="section1Image" ref={section1ImageRef} imageType="profile"
                  imageKey={section1ImageKey} setImageKey={setSection1ImageKey} imageDelete={props.imageDelete} />
              </div>

              <div className="col-sm-12 mt-4">
                <label className="form-label" htmlFor="section1TagLine">
                  Parents Name
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="D/O Malleswara Rao & Shiva Rajini Kumari"
                  name="section1TagLine"
                  id="section1TagLine"
                  value={section1TagLine}
                  onChange={(e) => setSection1TagLine(e.target.value)}
                />
              </div>
            </div>
            <StepperNavigationButtons index={props.index} steps={props.steps} navigate={props.navigate} />
          </div>
        </form >
      </div >
    </>
  )
});

export default BirthdayDetails;

